import { DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutIdleTrailerReport extends Layout {
    excludabletextboxDispatcher: ExcludableTextbox;
    excludabletextboxFleet: ExcludableTextbox;
    excludabletextboxTrailer: ExcludableTextbox;
    excludabletextboxTrailerType: ExcludableTextbox;
    sourceIdleTrailer: DataSource;
    switchReportType: Switch;
    textboxGroupBy: Textbox;
    textboxMinimumDays: Textbox;
    textboxStateZoneLocation: Textbox;
    textboxStateZoneSearch: Textbox;
    textboxStatus: Textbox;
}
